<template>
   <v-card>
      <v-card-title>Corporate Experience Summary</v-card-title>
      <v-card-subtitle>For Corporate Member application only</v-card-subtitle>
      <v-card-text>
         Applicants summary experience is to be listed here. These experience shall at the minimum demonstrate at least
         six months full time equivalent experience for at least three of the following scope of planning works.
         Please indicate the period of full time experience and details of this summary should be authorised in the MIP log sheet.
         (All log sheet must be verified by the employer/supervisor who is a corporate member of MIP).
      </v-card-text>
      <v-card-text>
         <v-simple-table dense>
            <template v-slot:default>
               <thead>
                  <tr class="grey darken-1">
                     <th class="text-left" width="40"><div class="text-white">NO.</div></th>
                     <th class="text-left" width="350">
                        <div class="text-white">
                           SCOPE
                           <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                 <v-icon v-bind="attrs" v-on="on" color="yellow lighten-2">mdi-help-rhombus</v-icon>
                              </template>
                              <span>SCOPE OF PLANNING WORKS</span>
                           </v-tooltip>
                        </div>
                     </th>
                     <th class="text-left">
                        <div class="text-white">
                           DESCRIPTION
                           <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                 <v-icon v-bind="attrs" v-on="on" color="yellow lighten-2">mdi-help-rhombus</v-icon>
                              </template>
                              <span>BRIEF DESCRIPTION OF EXPERIENCE</span>
                           </v-tooltip>
                        </div>
                     </th>
                     <th class="text-left" width="200">
                        <div class="text-white">
                           EXPERIENCE
                           <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                 <v-icon v-bind="attrs" v-on="on" color="yellow lighten-2">mdi-help-rhombus</v-icon>
                              </template>
                              <span>PERIOD OF FULL-TIME EQUIVALENT EXPERIENCE IN MONTHS OR YEARS</span>
                           </v-tooltip>
                        </div>
                     </th>
                  </tr>
               </thead>
               <tbody>
                  <tr
                     v-for="item in datalist"
                     :key="item.expid"
                     class="border grey lighten-4"
                  >
                     <td class="border align-top pt-2">{{ item.expid }}</td>
                     <td class="border align-top pt-2">{{ item.scopeofwork }}</td>
                     <td class="border align-top">
                        <v-textarea auto-grow outlined rows="1" row-height="15" v-model="item.description" dense solo style="font-size: 10pt;"></v-textarea>
                     </td>
                     <td class="border align-top">
                        <v-textarea auto-grow outlined rows="1" row-height="15" v-model="item.fulltimeperiod" dense solo style="font-size: 10pt;"></v-textarea>
                     </td>
                  </tr>
               </tbody>
            </template>
         </v-simple-table>
      </v-card-text>
      <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn color="primary" @click="update">
            Update Summary Experience
         </v-btn>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-title>Log Sheet</v-card-title>
      <v-card-text>
         <p>You can download the Log Sheet template <a href="#">here.</a></p>
         <div class="d-flex">
            <v-file-input show-size accept=".doc,.docx,application/msword,.pdf" label="Upload File" v-model="uploadfile" dense solo class="mr-3"></v-file-input>
            <v-btn color="primary" :disabled="uploading || (!uploadfile)" @click="uploadlogsheet">
               Upload Log Sheet
            </v-btn>
         </div>
         <div class="d-flex">
            <v-text-field v-model="document" label="Uploaded Log Sheet" readonly class="mr-3" dense solo></v-text-field>
            <v-btn color="primary" @click="openview('/' + documentpath + '/' + document)">
               View File
            </v-btn>
         </div>
      </v-card-text>
   </v-card>
</template>

<script>
const axios = require('axios')

export default {
   name: 'TableCorpExp',
   components: {

   },

   data() {
      return {
         userid: 0,
         deflist: [
            { itemid: 0, expid: 1, scopeofwork: 'Development Control', description: '', fulltimeperiod: '', document: '', documentpath: ''},
            { itemid: 0, expid: 2, scopeofwork: 'Development Plans (Structure Plans & Local Plans etc).', description: '', fulltimeperiod: '', document: '', documentpath: ''},
            { itemid: 0, expid: 3, scopeofwork: 'Site Planning & Layout Preparation for Planning Permission', description: '', fulltimeperiod: '', document: '', documentpath: ''},
            { itemid: 0, expid: 4, scopeofwork: 'Special Studies or Report Preparation (LCP or inputs) EIA, SIA or TIA etc.', description: '', fulltimeperiod: '', document: '', documentpath: ''},
            { itemid: 0, expid: 5, scopeofwork: 'Research & Development', description: '', fulltimeperiod: '', document: '', documentpath: ''},
            { itemid: 0, expid: 6, scopeofwork: 'Teaching', description: '', fulltimeperiod: '', document: '', documentpath: ''},
            { itemid: 0, expid: 7, scopeofwork: 'Administration', description: '', fulltimeperiod: '', document: '', documentpath: ''},
            { itemid: 0, expid: 8, scopeofwork: 'Project Management & Feasibility Studies', description: '', fulltimeperiod: '', document: '', documentpath: ''},
            { itemid: 0, expid: 9, scopeofwork: 'Advocacy/Expert Witness', description: '', fulltimeperiod: '', document: '', documentpath: ''},
         ],
         datalist: [],
         isempty: true,
         uploadfile: null,
         document: '',
         documentpath: '',
         uploading: false,
      }
   },

   methods: {

      setuserid(pUserID) {
         this.userid = pUserID
         this.initialize()
      },

      initialize() {
         this.$nextTick(() => {
            this.loadgrid()
            this.loadlogsheet()
         })
      },

      checkCompleted() {
         if ((!this.isempty) && (this.document !== '')) {
            this.$emit('CorpExpCompleted')
         }
      },

      loadgrid() {
         var targetPath = ''
         if (this.userid !== 0) {
            targetPath = '/member/empcorpexp/list/' + this.userid // get id from property
         } else {
            targetPath = '/member/empcorpexp/list' // get id from current login session (server-side)
         }
         axios.get(targetPath)
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  if (rtn.data.length > 0) {
                     this.datalist = rtn.data
                     this.isempty = false
                     this.checkCompleted()
                  } else {
                     this.datalist = this.deflist
                     this.isempty = true
                  }
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      },

      loadlogsheet() {
         var targetPath = ''
         if (this.userid !== 0) {
            targetPath = '/member/empcorpexp/logsheet/' + this.userid // get id from property
         } else {
            targetPath = '/member/empcorpexp/logsheet' // get id from current login session (server-side)
         }
         axios.get(targetPath)
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.document = rtn.data.document
                  this.documentpath = rtn.data.documentpath
                  this.checkCompleted()
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      },

      uploadlogsheet() {
         var targetPath = '/member/empcorpexp/uploadlog'
         var data = new FormData()

         data.append('userid', this.userid)
         if (this.uploadfile) {
            data.append('document', this.uploadfile)
         }

         this.uploading = true
         axios.post(targetPath, data, {
            headers: {
               'Content-Type': 'multipart/form-data'
            }
         })
         .then((resp) => {
            this.uploading = false
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.uploadfile = null
                  this.initialize()
                  this.checkCompleted()
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      },

      update() {
         var targetPath = ''
         var data = {
            userid: this.userid,
            datalist: JSON.stringify(this.datalist) // passing array
         }

         if (this.isempty) {
            targetPath = '/member/empcorpexp/add'
         } else {
            targetPath = '/member/empcorpexp/update'
         }

         axios.post(targetPath, data, {
            headers: {
               'Content-Type': 'application/json' // must use this one coz passing array
            }
         })
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.initialize()
                  this.checkCompleted()
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      },

      openview(pUrl) {
         window.open(pUrl)
      },

   },

   mounted() {
      this.$emit('CorpExpMounted')
   },

}
</script>
